import { useEffect } from 'react';
import { useLocation } from 'react-router';
import moment from 'moment';

const packageJson = require('../../../../../package.json');

/**
 * Clears all caches EXCEPT the workbox precache, which is needed for offline support.
 */
async function clearNonPrecaches() {
  const keyList = await caches?.keys?.();
  if (!keyList) return;
  await Promise.all(keyList.filter(key => !key.startsWith('workbox-precache') && key !== 'static-resources').map(key => caches.delete(key)));
}

const CacheBuster = () => {
  let location = useLocation();

  useEffect(() => {
    console.log(
      `Worker Portal - Initial cache already cleared: ${
        localStorage.getItem('initialCacheClearedForWorkerPortal') || 'No'
      }`,
    );
    if (localStorage.getItem('initialCacheClearedForWorkerPortal') !== 'Yes') {
      clearNonPrecaches()
        .then(() => {
          localStorage.setItem('initialCacheClearedForWorkerPortal', 'Yes');
          console.log('Worker Portal - Initial cache cleared');
        })
        .catch(e => console.log('Worker Portal - Initial cache clearing failed: ', e));
    }
  }, []);

  useEffect(() => {
    if (!window.location.href?.includes('localhost')) {
      console.log('Worker Portal - Fetching latest build date');
      fetch(`${process.env.REACT_APP_WORKER_PORTAL_WEB_URL}/meta.json?${new Date().getTime()}`, {
        cache: 'no-cache',
      })
        .then(response => response.json())
        .then(meta => {
          const latestVersionDate = Number(meta.buildDate || 0);
          const currentVersionDate = Number(packageJson.buildDate || 0);
          console.log(
            `Worker Portal - Latest version: ${
              latestVersionDate ? moment(latestVersionDate).format('MMM DD, YYYY hh:mmA') : 0
            }, Current version: ${currentVersionDate ? moment(currentVersionDate).format('MMM DD, YYYY hh:mmA') : 0}`,
          );
          if (latestVersionDate > currentVersionDate) {
            // Try the global registration first, then query the SW directly
            const getWaitingRegistration = async () => {
              const global = (window as any).__SW_REGISTRATION__;
              if (global?.waiting) return global;
              if (navigator.serviceWorker) {
                const reg = await navigator.serviceWorker.getRegistration();
                if (reg?.waiting) return reg;
              }
              return null;
            };

            getWaitingRegistration().then(registration => {
              if (registration?.waiting) {
                // Tell the waiting service worker to activate (it already has fresh assets precached)
                registration.waiting.postMessage({ type: 'SKIP_WAITING' });
                navigator.serviceWorker?.addEventListener('controllerchange', () => {
                  console.log('Worker Portal - New service worker activated. Reloading!');
                  window.location.reload();
                });
              } else {
                // Fallback: no waiting SW — unregister the old SW, clear ALL caches, and reload
                const unregisterSW = navigator.serviceWorker
                  ? navigator.serviceWorker.getRegistration().then(reg => reg?.unregister())
                  : Promise.resolve();

                unregisterSW
                  .then(() =>
                    caches?.keys?.()?.then((keyList = []) => Promise.all(keyList.map(key => caches.delete(key)))),
                  )
                  .then(() => {
                    console.log('Worker Portal - SW unregistered, cache cleared. Reloading the website!');
                    window.location.reload();
                  })
                  .catch(e => console.log('Worker Portal - Cache clearing failed: ', e));
              }
            });
          }
        })
        .catch(e => console.log('Worker Portal - An error occurred while fetching meta.json: ', e));
    }
  }, [location?.pathname]);
  return null;
};

export default CacheBuster;
